import { Injectable, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslationService } from './translation.service'

@Injectable()
export class BrandTitleStrategy extends TitleStrategy {
  private title = inject(Title)
  private translationService = inject(TranslationService)

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot)
    const brandName = this.translationService.getBrandNameText()
    this.title.setTitle(
      pageTitle && pageTitle !== brandName
        ? this.translationService.getBrandPageTitleText(pageTitle)
        : brandName,
    )
  }
}
